import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { Banner } from '@calendly/ui/components/banner';
import { Link as CuiLink } from '@calendly/ui/components/link';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useGetUserQuery } from 'common';
import { useFetchJoinableOrganizationsQuery, useSetActivationDataForJoinOrgBannerMutation, RequestToJoinModal } from 'features/organization';
const joinAnOrgButtonCss = "j1eagsct";
const JoinAnOrgButton = forwardRef((props, ref) => {
  const as = 'button';
  const underline = false;
  return <CuiLink ref={ref} {...props} as={as} underline={underline} className={classNames(joinAnOrgButtonCss, props.className)} />;
});
const JoinAnOrgBannerBody = () => {
  const {
    isSuccess,
    data
  } = useFetchJoinableOrganizationsQuery();
  const {
    data: {
      id
    }
  } = useGetUserQuery();
  const [update] = useSetActivationDataForJoinOrgBannerMutation();
  const [isOpenModal, setJoinAnOrgIsOpen] = useState(false);
  const onCloseBanner = () => {
    update({
      id
    });
  };
  const onCloseModal = () => setJoinAnOrgIsOpen(false);
  const showJoinAnOrgModal = () => {
    setJoinAnOrgIsOpen(true);
  };
  if (!isSuccess) {
    return null;
  }
  const foundJoinableOrganization = data.collection.length > 0 && !data.collection.find(({
    organizationInvitation: i
  }) => i);
  if (!foundJoinableOrganization) return null;
  return <>
      <Banner onClose={onCloseBanner}>
        <BodyText weight="bold">
          {HtmlParser(I18n.t('publisher.organization.join.banner'))}
          {' '}
          <JoinAnOrgButton onClick={showJoinAnOrgModal}>
            {HtmlParser(I18n.t('publisher.organization.join.banner_link'))}
          </JoinAnOrgButton>
        </BodyText>
      </Banner>
      <RequestToJoinModal isOpen={isOpenModal} onClose={onCloseModal} />
    </>;
};
export const JoinAnOrgBanner = () => {
  const {
    data: {
      activation_data: activationData
    } = {}
  } = useGetUserQuery();
  if (!activationData || activationData.has_closed_join_an_org_banner) return null;
  return <JoinAnOrgBannerBody />;
};

require("./index.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.js");